import {
  PUBLIC_SERVICE_CATEGORY_REQUEST,
  PUBLIC_SERVICE_CATEGORY_MUTATION_REQUEST,
  PUBLIC_SERVICE_CATEGORY_FAILURE,
  FETCH_PUBLIC_SERVICE_CATEGORIES_SUCCESS,
  CREATE_PUBLIC_SERVICE_CATEGORY_SUCCESS,
  UPDATE_PUBLIC_SERVICE_CATEGORY_SUCCESS,
  DELETE_PUBLIC_SERVICE_CATEGORY_SUCCESS,
} from "../action/types";

const initialState = {
  categories: [],
  loading: false,
  mutating: false,
  error: null,
};

const publicServiceCategoryReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case PUBLIC_SERVICE_CATEGORY_REQUEST:
      return { ...state, loading: true, error: null };
    case PUBLIC_SERVICE_CATEGORY_MUTATION_REQUEST:
      return { ...state, mutating: true, error: null };
    case FETCH_PUBLIC_SERVICE_CATEGORIES_SUCCESS:
      return {
        ...state,
        loading: false,
        categories: payload?.data ?? (Array.isArray(payload) ? payload : []),
      };
    case CREATE_PUBLIC_SERVICE_CATEGORY_SUCCESS:
      return {
        ...state,
        mutating: false,
        categories: [
          payload,
          ...state.categories.filter(
            (category) =>
              String(category.id || category._id) !==
              String(payload?.id || payload?._id),
          ),
        ],
      };
    case UPDATE_PUBLIC_SERVICE_CATEGORY_SUCCESS:
      return {
        ...state,
        mutating: false,
        categories: state.categories.map((category) =>
          String(category.id || category._id) ===
          String(payload?.id || payload?._id)
            ? payload
            : category,
        ),
      };
    case DELETE_PUBLIC_SERVICE_CATEGORY_SUCCESS:
      return {
        ...state,
        mutating: false,
        categories: state.categories.filter(
          (category) =>
            String(category.id || category._id) !==
            String(payload?.id || payload?._id),
        ),
      };
    case PUBLIC_SERVICE_CATEGORY_FAILURE:
      return { ...state, loading: false, mutating: false, error: payload };
    default:
      return state;
  }
};

export default publicServiceCategoryReducer;
